export default __webpack_public_path__ + "static/media/status_wait.14ca99e1.svg";